import React, { useEffect } from 'react';
import styles from './SelectTopUpMethod.module.scss';
import SelectTopUpMethodItem from '../SelectTopUpMethodItem/SelectTopUpMethodItem';
import clsx from 'clsx';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getTypePaymentList } from '../../../../redux/actions/app/getTypePayment';
import { imgPath } from '../../../../utils/imgPath';

export const itemCart = { id: null, icon: '../img/wallet-logo.svg', name: 'DSWallet', comission: 0 };
const SelectTopUpMethod = ({ cart, total = 0 }) => {
  const {
    getTypePaymentList: { data },
  } = useSelector((state) => state.app);
  const {
    authUser: { data: userData },
  } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getTypePaymentList());
  }, []);

  return (
    <>
      {!cart && <div className={clsx(styles.title)}>Способ пополнения</div>}
      <div className={clsx(styles.list)}>
        {cart && <SelectTopUpMethodItem {...itemCart} disabled={total > userData?.balance} />}
        {[...data]
          .sort((a, b) => a.order - b.order)
          ?.map((item) => (
            <SelectTopUpMethodItem {...item} icon={imgPath(item.icon)} />
          ))}
      </div>
    </>
  );
};

export default SelectTopUpMethod;
